angular.module('mapes')
.controller('messageController',
    function ($scope, $rootScope, NotificationsService) {
      $scope.$on('showMessage', function () {
        $scope.message = NotificationsService.message;
        $scope.type = NotificationsService.type;
        $rootScope.isSearching = false;
      });
      $scope.$on('closeMessage', function () {
        $scope.closeMessage();
      });
      $scope.closeMessage = function () {
        $scope.message = $scope.type = '';
      };
    });